export default __webpack_public_path__ + "static/media/nhlFantasyPWRSBannerTitle.c2ba3c17.png";